module.exports = __webpack_public_path__ + "assets/0f88ad512d652b8c36f7bc66ac9dea9e.svg";